import {analytics} from './analytics';
import {posthogSink} from './sinks/posthog';
import {sentrySink} from './sinks/sentry';
import {faroSink} from './sinks/faro';

analytics.registerSink(posthogSink);
analytics.registerSink(sentrySink);
analytics.registerSink(faroSink);

export {analytics};
export type {AnalyticsSink, LogLevel, Props} from './types';
